import styles from "./index.module.css";

const CaixaStrip = () => (
  <div className={styles.strip}>
    <span className={styles.text}>
      Sorteios oficiais realizados pela{" "}
      <strong>Caixa Econômica Federal</strong>
    </span>
  </div>
);

export default CaixaStrip;
